import type {
  Attributes,
  JSONContent,
  MarkdownParseHelpers,
  MarkdownRendererHelpers,
  MarkdownToken,
} from "@tiptap/core"
import Highlight from "@tiptap/extension-highlight"
import { DEFAULT_HIGHLIGHT_COLOR_NAME, HIGHLIGHT_COLOR_MAP } from "../../util/colors"
import { htmlMarkTokenizer, parseHtmlMark, renderHtmlMark } from "../../util/markdown-html-mark"

export const HighlightContentExtension = Highlight.extend({
  addAttributes() {
    // Override the default color: our chosen default instead of null.
    const parent: Attributes = this.parent!()
    return {
      ...parent,
      color: {
        ...parent.color,
        default: HIGHLIGHT_COLOR_MAP[DEFAULT_HIGHLIGHT_COLOR_NAME],
        // The stock parser returns "" for a bare <mark>, which would override the default.
        parseHTML: (element: HTMLElement) => parent.color?.parseHTML?.(element) || null,
      },
    }
  },

  parseHTML() {
    return [
      ...(this.parent?.() ?? []),
      {
        tag: "span",
        consuming: false,
        getAttrs: (element) => {
          const bgColor = element.style.backgroundColor
          return bgColor && bgColor !== "transparent" ? { color: bgColor } : false
        },
      },
    ]
  },

  markdownTokenName: "highlight",
  markdownTokenizer: htmlMarkTokenizer("highlight", "mark"),
  parseMarkdown: (token: MarkdownToken, helpers: MarkdownParseHelpers) =>
    parseHtmlMark(
      token,
      helpers,
      "highlight",
      HIGHLIGHT_COLOR_MAP,
      HIGHLIGHT_COLOR_MAP[DEFAULT_HIGHLIGHT_COLOR_NAME],
    ),
  renderMarkdown: (node: JSONContent, helpers: MarkdownRendererHelpers) =>
    renderHtmlMark(node, helpers, "mark", HIGHLIGHT_COLOR_MAP),
})
